<template>
  <div>
    <div class="bg-scroll bg-center bg-cover about">
      <h1 class="is-size-1 is-size-2-mobile has-text-white font-second--bold">About</h1>
    </div>
    <div>
      <div class="about-body">
        <!-- <h1 class="is-size-2 font-second--bold">About Me</h1> -->
        <div class="section">
          <p class="content is-size-4 is-size-5-mobile font-main">
            I graduated with a business degree and Masters in Bible at Bob Jones
            University. I then attended Dropsie College in Philadelphia for its
            last year. I then studied at Hebrew Union College and received at
            MPhil and PhD degrees. I taught at Mid-Continent College for two
            years and at Southern Seminary for the last 22 years.
          </p>
          <p class="content is-size-4 is-size-5-mobile font-main">
            I hold to the The 2nd London Confession (also called the The Baptist
            Confession of Faith 1689) as the Confession of Faith that I believe.
            I have been greatly influenced by the Westminster Confession, the
            basis of The 2nd London Confession, and its catechisms. I
            particularly enjoy reading Puritan writers and later writers
            influenced by the Puritans. I am also a young earth creationist.
          </p>
          <p class="content is-size-4 is-size-5-mobile font-main">
            I am married to Donna (Sanford) Fuller. We have three children,
            David, Christine, and Katherine. We also have a grandchild, Melba
            Jean Fuller, daughter of David and Marissa Fuller. We enjoy family,
            exercising, and studying the Bible.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'About',
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/_vars.scss';
@import '@/assets/css/_colors.scss';
.about {
  background-image: $mask-dark, url('../assets/HebrewMan.jpg');
  position: relative;
  overflow-y: visible;
  height: 20em;
  & > h1 {
    position: absolute;
    top: 50%;
    left: 10%;
  }
}
.about-body {
  min-height: 100vh;
  width: 100vw;
  width: 100%;
  padding: 1em 3em;
  border: 1px solid $primary;
  padding: 5%;
}
</style>
